import { ChangeLanguage, TranslationsActions, TranslationsActionTypes } from '@app/core/actions/translations';
import { createHandler, createReducer } from '@app/util';
import * as R from 'ramda';


export interface State {
  currentLanguage: string;
}

export const initialState: State = {
  currentLanguage: 'en'
};

const changeLanguageHandler = createHandler(TranslationsActionTypes.ChangeLanguage, (state: State, action: ChangeLanguage) =>
  R.mergeRight(state, {
    currentLanguage: action.payload
  })
);

export const reducer = createReducer<State, TranslationsActions>([
  changeLanguageHandler
], initialState);

export const getCurrentLanguage = (state: State) => state.currentLanguage;
